import {
    DEALERREQCASHLIFTING_SUCCESS,
    DEALERREQCASHLIFTING_FAILED,
    RESET_DEALERREQCASHLIFTING,
    LOADING_DEALERREQCASHLIFTING,
    NETWORK_ERROR_DEALERREQCASHLIFTING
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERREQCASHLIFTING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERREQCASHLIFTING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERREQCASHLIFTING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERREQCASHLIFTING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERREQCASHLIFTING:
            return (state = initialState);
        default:
            return state;
    }
};
